import { render, staticRenderFns } from "./NewVerticalNavMenuNotifications.vue?vue&type=template&id=28477926"
import script from "./NewVerticalNavMenuNotifications.vue?vue&type=script&lang=js"
export * from "./NewVerticalNavMenuNotifications.vue?vue&type=script&lang=js"
import style0 from "./NewVerticalNavMenuNotifications.vue?vue&type=style&index=0&id=28477926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports